<template>

  <div id="page-lot-list">

    <vx-card ref="filterCard" title="Filtros" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Status</label>
          <v-select :options="statusOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Alerta</label>
          <v-select :options="alertOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="alertFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Custódia</label>
          <v-select :options="custodyOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="custodyFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Período</label>
          <v-select :options="timeOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="timeFilter" />
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ lotsData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : lotsData.length }} of {{ lotsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Detalhes</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Arquivar</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Imprimir</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Exportar</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="lotsData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import CellRendererOrigin from './cell-renderer/CellRendererOrigin.vue'
import CellRendererLocation from './cell-renderer/CellRendererLocation.vue'
import CellRendererCustody from './cell-renderer/CellRendererCustody.vue'
import CellRendererProducts from './cell-renderer/CellRendererProducts.vue'
import CellRendererDate from './cell-renderer/CellRendererDate.vue'
import CellRendererDateOnly from './cell-renderer/CellRendererDateOnly.vue'
import CellRendererDistance from './cell-renderer/CellRendererDistance.vue'


export default {
  components: {
    AgGridVue,
    vSelect,
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    CellRendererOrigin,
    CellRendererLocation,
    CellRendererCustody,
    CellRendererProducts,
    CellRendererDate,
    CellRendererDateOnly,
    CellRendererDistance
  },
  data () {
    return {
      lots: [],
      // Filter Options
      statusFilter: { label: 'Todos', value: 'all' },
      statusOptions: [
        { label: 'Todos', value: 'all' },
        { label: 'Aguardando envio', value: 'Aguardando envio' },
        { label: 'Aguardando coleta', value: 'Aguardando coleta' },
        { label: 'Em rota de entrega', value: 'Em rota de entrega' },
        { label: 'Em rastreamento', value: 'Em rastreamento' },
        { label: 'Entregue', value: 'Entregue' },
        { label: 'Recebido', value: 'Recebido' }
      ],
      alertFilter: { label: 'Todos', value: 'all' },
      alertOptions: [
        { label: 'Todos', value: 'all' },
        { label: 'Licença vencida', value: 'Licença vencida' },
        { label: 'Fora de validade', value: 'Fora de validade' },
        { label: 'Atrasado', value: 'Atrasado' },
        { label: 'Nota ruim', value: 'Nota ruim' }
      ],
      timeFilter: { label: 'Todos', value: 'all' },
      custodyFilter: { label: 'Todos', value: 'all' },
      searchQuery: '',
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'PEDIDO NO.',
          field: 'orderId',
          width: 250,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'NF NO.',
          field: 'nfId',
          filter: true,
          width: 150
        },
        {
          headerName: 'STATUS',
          field: 'transitState',
          filter: true,
          width: 300,
          cellRendererFramework: 'CellRendererStatus'
        },
        {
          headerName: 'CUSTÓDIAS',
          field: 'historyCustodies',
          cellRendererFramework: 'CellRendererCustody',
          width: 250
        },
        {
          headerName: 'CONTA COM CUSTÓDIA',
          field: 'currentCompanyCustody',
          filter: true,
          width: 250
        },
        {
          headerName: 'statusFilterData',
          field: 'statusFilterData',
          hide: true,
          filter: true,
          width: 250
        },
        {
          headerName: 'alertFilterData',
          field: 'alertFilterData',
          hide: true,
          filter: true,
          width: 250
        },
        {
          headerName: 'PRODUTOS',
          field: 'Product',
          cellRendererFramework: 'CellRendererProducts',
          width: 225
        },
        {
          headerName: 'LOCALIZAÇÃO',
          field: 'locationName',
          filter: true,
          width: 300
        },
        {
          headerName: 'DISTÂNCIA',
          field: 'deliveryCompanyDistance',
          cellRendererFramework: 'CellRendererDistance',
          filter: true,
          width: 200
        },
        {
          headerName: 'DATA EST ENTREGA',
          field: 'estimatedDeliveryDate',
          filter: true,
          width: 215,
          cellRendererFramework: 'CellRendererDateOnly'
        },
        {
          headerName: 'ATUALIZAÇÃO',
          field: 'updatedAt',
          filter: true,
          width: 215,
          cellRendererFramework: 'CellRendererDate'
        },
        {
          headerName: 'AÇÕES',
          field: 'transactions',
          width: 150,
          cellRendererFramework: 'CellRendererActions'
        }
      ],
      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
        CellRendererOrigin,
        CellRendererLocation,
        CellRendererCustody,
        CellRendererProducts,
        CellRendererDate,
        CellRendererDateOnly,
        CellRendererDistance
      }
    }
  },
  watch: {
    statusFilter (obj) {
      this.setColumnFilter('statusFilterData', obj.value)
    },
    custodyFilter (obj) {
      this.setColumnFilter('currentCompanyCustody', obj.value)
    },
    alertFilter (obj) {
      this.setColumnFilter('alertFilterData', obj.value)
    }
    /*timeFilter (obj) {
      this.setColumnFilter('deviceTimestamp', obj.value)
    }*/
  },
  computed: {
    timeOptions () {
      const today = new Date()
      return [
        { label: 'Todos', value: 'all' },
        { label: 'Hoje', value: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0) },
        { label: 'Últimos 7 dias', value: new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)) },
        { label: 'Últimos 15 dias', value: new Date(new Date().getTime() - (15 * 24 * 60 * 60 * 1000)) },
        { label: 'Últimos 30 dias', value: new Date(new Date().getTime() - (30 * 24 * 60 * 60 * 1000)) },
        { label: 'Últimos 60 dias', value: new Date(new Date().getTime() - (60 * 24 * 60 * 60 * 1000)) },
        { label: 'Últimos 90 dias', value: new Date(new Date().getTime() - (90 * 24 * 60 * 60 * 1000)) }
      ]
    },
    custodyOptions () {
      const result = [{ label: 'Todos', value: 'all' }]
      const options = this.lotsData.map(e => { return { label: e.currentCompanyCustody, value: e.currentCompanyCustody } })
      for (let i = 0; i < options.length; i++) if (!result.map(e => e.label).includes(options[i].label)) result.push(options[i])
      return result
    },
    lotsData () {
      return this.lots
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
      this.statusFilter = { label: 'Todos', value: 'all' }
      this.custodyFilter = { label: 'Todos', value: 'all' }
      this.alertFilter = { label: 'Todos', value: 'all' }
      this.timeFilter = { label: 'Todos', value: 'all' }
      this.$refs.filterCard.removeRefreshAnimation()
      this.getLots()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    async getLots () {
      try {
        this.$vs.loading()
        const { data } = await this.$http.get(
          '/api/v1/admin/company/lots',
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        this.lots = data
      } catch (err) {
        console.log(err)
      } finally {
        this.$vs.loading.close()
      }
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  async created () {
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    await this.getLots()
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
